module.exports = __webpack_public_path__ + "static/media/whatsapp.246dce86.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/svgs/whatsapp.svg
// module id = 248
// module chunks = 1